<template>
  <div>
    <div class="row no-wrap">
      <!-- <div class="row justify-left no-wrap full-width"> -->
        <q-toggle
          v-if="modelType === 3 && (theModel as SelectionProjectStageFilterSend).Positive !== undefined"
          v-model="(theModel as SelectionProjectStageFilterSend).Positive"
          :class="`q-pa-none toggle-checkbox q-mr-none ${modelType === 3 ?'unset-items-center' : 'items-center'}`"
          checked-icon="add"
          color="primary"
          label=""
          size="xs"
          unchecked-icon="remove"
        />
        <!-- class="text-no-wrap" -->
        <div style="margin-top: 3px;">{{ (theModel as SelectionProjectStageFilterSend).Stage.Name }}</div>
        <q-btn
          class="q-px-none q-mx-none unset-items-center"
          style="margin-top: 1px; margin-left: 2px;"
          flat
          dense
          v-if="modelType === 3"
          :aria-label="$t('delete_filter')"
          icon="close"
          size="sm"
          tabindex="-1"
          color="grey-8"
          @click="emitDelete"
        >
          <q-tooltip :delay="1000">
            {{ $t('remove') }}
          </q-tooltip>
        </q-btn>

      <!-- </div> -->
      <!-- <div class="row justify-left no-wrap full-width q-pl-sm"> -->
        <q-checkbox
          v-model="(theModel as SelectionProjectStageFilterSend).FilterType"
          :true-value="1"
          :false-value="0"
          :toggle-indeterminate="false"
          :keep-color="false"
          checked-icon="event"
          unchecked-icon="event"
          size="sm" color="primary"
          style="margin-top: -5px;"
          class="q-mx-none q-px-none cursor-pointer"
        />
        <!-- q-option-group
            size="25px"
            v-model="(theModel as SelectionProjectStageFilterSend).FilterType"
            :options="[
              {
                label: $t('on_stage'),
                value: 0
              },
              {
                label: $t('set_to_stage'),
                value: 1
              }
            ]"
            color="primary"
            inline
            dense
          /-->
      <!-- </div> -->
    </div>
      <div v-if="(theModel as SelectionProjectStageFilterSend).FilterType" class="row justify-left q-pl-sm full-width">
        <!-- <div class="row items-center">   -->
          <div :class="['cursor-pointer', 'text-grey-8' ]" style="margin-top: 3px;">
            {{ $t('after_label') }} &nbsp;
          </div> 
          <!-- <q-input outlined dense style="min-width: 95px; max-width: 100px;"
            class="thin-input-date q-my-auto" :color="sdateInnerValid ? 'grey-7' : 'red'"
            v-model="sdateModel" mask="##.##.####" fill-mask="_" hide-bottom-space>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer" size="xs">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date :locale="dateLocale" minimal v-model="(theModel as SelectionProjectStageFilterSend).StartDate" 
                  mask="YYYY-MM-DDTHH:mm:ssZ">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup :label="$t('close_label')" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input> -->
          <div style="margin-top: 2px">
            <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" :style="'width: '+fieldWidth+'px; min-width: '+fieldWidth+'px; max-width: '+fieldWidth+'px;'" :teleport="true"
            v-model="(this.theModel as SelectionProjectStageFilterSend).StartDate" :enable-time-picker="false"
            :clearable="false" :required="true" :format="format" :text-input="textInputOptions" />
          </div>
          
          <div :class="['q-ml-xs', 'cursor-pointer', 'text-grey-8' ]" style="margin-top: 3px;">
            &nbsp;{{ $t('to') }} &nbsp;
          </div>

          <!-- <q-input outlined dense style="min-width: 95px; max-width: 100px;"
            class="thin-input-date q-my-auto" :color="edateInnerValid ? 'grey-7' : 'red'"
            v-model="edateModel" mask="##.##.####" fill-mask="_" hide-bottom-space
            :disable="(theModel as SelectionProjectStageFilterSend).EndDateIsToday">
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer" size="xs">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date :locale="dateLocale" minimal v-model="(theModel as SelectionProjectStageFilterSend).EndDate" 
                  mask="YYYY-MM-DDTHH:mm:ssZ">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup :label="$t('close_label')" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input> -->

          <div style="margin-top: 2px">
            <VueDatePicker utc="preserve" timezone="Europe/Moscow" :locale="$i18n.locale" :style="'width: '+fieldWidth+'px; min-width: '+fieldWidth+'px; max-width: '+fieldWidth+'px;'" 
            v-model="(this.theModel as SelectionProjectStageFilterSend).EndDate" :teleport="true" 
            :clearable="false" :disabled="theModel && (theModel as SelectionProjectStageFilterSend).EndDateIsToday"
            :format="format" :text-input="textInputOptions" :enable-time-picker="false" />
          </div>
        <!-- </div> -->
        <mosta-checkbox class="q-my-none q-py-none q-px-none items-center text-grey-8"
        @update:model-value="updateCheck" style="margin-left: 6px; margin-top: 4px;"
          v-model="(theModel as SelectionProjectStageFilterSend).EndDateIsToday" :label="$t('today_calendar')" />
      </div>
  </div>
</template>
  
<script lang="ts">
  import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
  import { SelectionProjectStageFilterSend } from '@/models/interfaces/entity-settings/filters/filters';
  import { SelectionFilterGroupSendDescriptor } from '@/models/etc/types';
  import { date } from 'quasar';
  import { calendarLocale } from '@/utils/auxfunc'
  import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
  
  // function formatDate(arg: any) {
  //   return arg ? date.formatDate(new Date(""+arg), 'DD.MM.YYYY') : this.$t('not_set_condition')
  // }

  @Component({
    name: 'ProjectStageDisplayItem',
    components: { MostaCheckbox },
  })
  export default class ProjectStageDisplayItem extends Vue {
    @Prop({ default: SelectionFilterGroupSendDescriptor.ProjectStages })
    modelType!: SelectionFilterGroupSendDescriptor
    @Prop({ default: {} as SelectionProjectStageFilterSend })
    modelValue: SelectionProjectStageFilterSend | undefined

    @Emit("update:modelValue") emitModelValue(arg: SelectionProjectStageFilterSend | undefined) { return arg; }
    @Emit("onDeleteClick") emitDelete(arg: any) { return arg; }

    sdateInnerModel: string = ''
    sdateInnerValid: boolean = true

    edateInnerModel: string = ''
    edateInnerValid: boolean = true

    dateLocale = calendarLocale

    get textInputOptions() {
      return {
        enterSubmit: true,
        tabSubmit: true,
        openMenu: 'toggle',
        rangeSeparator: '-',
        selectOnFocus: false,
        format: 'dd.MM.yyyy'
      }
    }

    format (date: Date): string {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}`;
    }

    get fieldWidth() {
      return 100;
    }

    @Watch('theModel.StartDate')
    m_watcher() {
      if (!this.theModel) { return }
      const sd = (this.theModel as SelectionProjectStageFilterSend).StartDate
      const ed = (this.theModel as SelectionProjectStageFilterSend).EndDate
      if (!(this.theModel as SelectionProjectStageFilterSend).EndDateIsToday &&
        sd && ed && new Date(sd) > new Date(ed)) {
        (this.theModel as SelectionProjectStageFilterSend).EndDate = sd
      }
    }

    get sdateModel() {
      if ((this.theModel as SelectionProjectStageFilterSend).StartDate) {
        this.sdateInnerModel = date.formatDate(new Date(""+(this.theModel as SelectionProjectStageFilterSend).StartDate), 'DD.MM.YYYY')
      } else {
        this.sdateInnerModel = ''
      }
      return this.sdateInnerModel
    }

    set sdateModel(arg: string) {
      if (arg) {
        this.sdateInnerModel = arg;
        
        if (!this.sdateInnerModel.includes('_')) {
          const datem = date.extractDate(arg+'T03:00:00', "DD.MM.YYYYTHH:mm:ss")
          this.sdateInnerValid = true;
          (this.theModel as SelectionProjectStageFilterSend).StartDate = new Date(datem)
        } else {
          this.sdateInnerValid = false;
          (this.theModel as SelectionProjectStageFilterSend).StartDate = undefined
        }
      } else {
        this.sdateInnerValid = false;
          (this.theModel as SelectionProjectStageFilterSend).StartDate = undefined
      }
    }

    get edateModel() {
      if ((this.theModel as SelectionProjectStageFilterSend).EndDate) {
        this.edateInnerModel = date.formatDate(new Date(""+(this.theModel as SelectionProjectStageFilterSend).EndDate), 'DD.MM.YYYY')
      } else {
        this.edateInnerModel = ''
      }
      return this.edateInnerModel
    }

    set edateModel(arg: string) {
      if (arg) {
        this.edateInnerModel = arg;
        
        if (!this.edateInnerModel.includes('_')) {
          const datem = date.extractDate(arg+'T03:00:00', "DD.MM.YYYYTHH:mm:ss")
          this.edateInnerValid = true;
          (this.theModel as SelectionProjectStageFilterSend).EndDate = new Date(datem)
        } else {
          this.edateInnerValid = false;
          (this.theModel as SelectionProjectStageFilterSend).EndDate = undefined
        }
      } else {
        this.edateInnerValid = false;
          (this.theModel as SelectionProjectStageFilterSend).EndDate = undefined
      }
    }

    formatSDate(arg: any) {
      return arg ? date.formatDate(new Date(""+arg), 'DD.MM.YYYY') : this.$t('start_date')
    }

    formatEDate(arg: any) {
      return arg ? date.formatDate(new Date(""+arg), 'DD.MM.YYYY') : this.$t('stop_date')
    }

    get theModel(): SelectionProjectStageFilterSend | undefined {
      return this.modelValue
    }

    set theModel(val: SelectionProjectStageFilterSend | undefined) {
      console.log('emit ')
      console.log(val)
      this.emitModelValue(val)
    }

    updateCheck(val: any) {
      if (!this.theModel) { return }
      if (val) {
        this.theModel.EndDate = undefined
      } else {
        this.theModel.EndDate = new Date()
      }
    }

    get innerModel(): any {
      if ((this.theModel as SelectionProjectStageFilterSend).EndDateIsToday) {
        return (this.theModel as SelectionProjectStageFilterSend).StartDate ? 
          date.formatDate(new Date(""+(this.theModel as SelectionProjectStageFilterSend).StartDate), 'YYYY-MM-DDTHH:mm:ss.000Z', undefined, undefined, 3) : ''
      } else {
        return {
          from: (this.theModel as SelectionProjectStageFilterSend).StartDate ? 
          date.formatDate(new Date(""+(this.theModel as SelectionProjectStageFilterSend).StartDate), 'YYYY-MM-DDTHH:mm:ss.000Z', undefined, undefined, 3) : '',
          to: (this.theModel as SelectionProjectStageFilterSend).EndDate ? 
          date.formatDate(new Date(""+(this.theModel as SelectionProjectStageFilterSend).EndDate), 'YYYY-MM-DDTHH:mm:ss.000Z', undefined, undefined, 3) : ''
        }
      }
    }

    set innerModel(arg: any) {
      if (!this.theModel || !arg) { return }

      if (!(this.theModel as SelectionProjectStageFilterSend).EndDateIsToday && 
      arg && !arg.to || !arg.from) {
        arg = {
          to: arg,
          from: arg
        }
      }
      this.theModel = {
        FilterType: this.theModel.FilterType,
        Stage: this.theModel.Stage,
        Positive: this.theModel.Positive,
        StartDate: (this.theModel as SelectionProjectStageFilterSend).EndDateIsToday ? (arg ? new Date(arg) : new Date()) : 
          (arg.from ? new Date(arg.from) : new Date()),
        EndDate: (this.theModel as SelectionProjectStageFilterSend).EndDateIsToday ? undefined : (arg.to ? new Date(arg.to) : new Date()),
        EndDateIsToday: this.theModel ? this.theModel.EndDateIsToday : false
      }
    }

    // get getElementName(): string {
    //   switch (this.modelType) {
    //     case SelectionFilterGroupSendDescriptor.Datestamps:
    //     return formatDate((this.theModel as SelectionProjectStageFilterSend).StartDate) +' - '+ 
    //         ((this.theModel as SelectionProjectStageFilterSend).EndDateIsToday ? this.$t('today_label') : formatDate((this.theModel as SelectionProjectStageFilterSend).EndDate))
    //     case SelectionFilterGroupSendDescriptor.ProjectStages:
    //       return formatDate((this.theModel as SelectionProjectStageFilterSend).StartDate) +' - '+ 
    //         ((this.theModel as SelectionProjectStageFilterSend).EndDateIsToday ? this.$t('today_label') : formatDate((this.theModel as SelectionProjectStageFilterSend).EndDate))
    //     default:
    //       return this.$t('untitled')
    //   }
    // }
  }
</script>
  
<style lang="scss">
</style>